// src/components/Navbar.js
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import "../assets/styles/navbar.css";

function Navbar() {
  const [navbarReveal, setNavbarReveal] = useState(false);
  const [dropdownReveal, setDropdownReveal] = useState(false);

  // Consolidated and sorted painting categories
  const paintingCategories = [
    "abstract",
    "animals",
    "asian",
    "cyclists",
    "dancers",
    "dogs",
    "flowers",
    "landscape",
    "littlepeople",
    "nudes",
    "portrait",
    "seascape",
    "still life",
    "other", // "other" stays at the bottom
  ].sort((a, b) => {
    // Custom sort to keep "other" at the end
    if (a === "other") return 1;
    if (b === "other") return -1;
    return a.localeCompare(b);
  });

  // Function to hide the mobile navbar
  const hideNavbar = () => {
    if (navbarReveal) {
      setNavbarReveal(false);
    }
  };

  // Function to toggle the mobile dropdown menu
  const toggleDropdown = () => {
    setDropdownReveal(!dropdownReveal);
  };

  // Function to hide the desktop dropdown when hovering over other links
  const handleHideDropdownOnOtherLinks = () => {
    if (dropdownReveal) {
      setDropdownReveal(false);
    }
  };

  return (
    <>
      {isMobile ? (
        // Mobile Navbar Structure
        <div className="navbar">
          <div className="navbar-container">
            {/* Hamburger icon - only visible when navbar is NOT revealed */}
            {!navbarReveal && (
              <div
                className="hamburger-lines"
                onClick={() => setNavbarReveal(true)}
              >
                <div className="line1"></div>
                <div className="line2"></div>
                <div className="line3"></div>
              </div>
            )}

            {/* Mobile menu and close button, conditionally rendered when navbarReveal is true */}
            {navbarReveal && (
              <>
                {" "}
                {/* Use a fragment to render siblings */}
                {/* Close button for the mobile menu */}
                <div
                  className="close-navbar"
                  onClick={() => {
                    hideNavbar(); // Hide the main navbar
                    setDropdownReveal(false); // Hide the dropdown
                  }}
                >
                  X
                </div>
                <div className="links">
                  {" "}
                  {/* The actual menu links container */}
                  {/* Home link - shown only if dropdown is not revealed */}
                  {!dropdownReveal && (
                    <Link
                      onClick={() => {
                        hideNavbar();
                        setDropdownReveal(false);
                      }}
                      className="home-top-link"
                      to="/"
                    >
                      home
                    </Link>
                  )}
                  {/* Portfolio dropdown trigger for mobile */}
                  <div
                    onClick={toggleDropdown}
                    className="mobile-portfolio-dropdown-container"
                  >
                    <div
                      className={`dropdown-portfolio-title ${
                        dropdownReveal ? "reveal" : ""
                      }`}
                    >
                      portfolio
                    </div>
                    <div
                      className={`down-arrow ${dropdownReveal ? "reveal" : ""}`}
                    >
                      ⌄
                    </div>
                  </div>
                  {/* Painting categories within the dropdown - shown when dropdownReveal is true */}
                  {dropdownReveal && (
                    <>
                      {paintingCategories.map((category) => (
                        <Link
                          key={category}
                          to={`/category/${category}`}
                          onClick={() => {
                            hideNavbar(); // Hide main navbar
                            setDropdownReveal(false); // Hide dropdown after selection
                          }}
                        >
                          {category}
                        </Link>
                      ))}
                    </>
                  )}
                  {/* Other navigation links - shown only if dropdown is not revealed */}
                  {!dropdownReveal && (
                    <>
                      <Link onClick={hideNavbar} to="/dog-portrait">
                        dog portraits
                      </Link>
                      <Link onClick={hideNavbar} to="/about">
                        my story
                      </Link>
                      <Link onClick={hideNavbar} to="/news">
                        news
                      </Link>
                      <Link onClick={hideNavbar} to="/workshops">
                        workshops
                      </Link>
                      <Link onClick={hideNavbar} to="/contact">
                        contact
                      </Link>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        // Desktop Navbar Structure
        <div className="pc-navbar-container">
          <div className="pc-logo">shriti fernando</div>
          <div className="pc-links">
            <Link onMouseOver={handleHideDropdownOnOtherLinks} to="/">
              home
            </Link>

            {/* Desktop Portfolio Dropdown */}
            <div
              onMouseEnter={() => setDropdownReveal(true)}
              onMouseLeave={() => setDropdownReveal(false)}
            >
              <Link
                to="/category/abstract" // Default link for "portfolio"
                onClick={() => setDropdownReveal(false)}
              >
                portfolio
              </Link>
              {dropdownReveal && (
                <div className="dropdown">
                  {paintingCategories.map((category) => (
                    <div key={category}>
                      <Link
                        to={`/category/${category}`}
                        onClick={() => setDropdownReveal(false)}
                      >
                        {category}
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Other Desktop Links */}
            <Link
              onMouseOver={handleHideDropdownOnOtherLinks}
              to="/dog-portrait"
            >
              dog portraits
            </Link>
            <Link onMouseOver={handleHideDropdownOnOtherLinks} to="/about">
              my story
            </Link>
            <Link onMouseOver={handleHideDropdownOnOtherLinks} to="/news">
              news
            </Link>
            <Link onMouseOver={handleHideDropdownOnOtherLinks} to="/workshops">
              workshops
            </Link>
            <Link onMouseOver={handleHideDropdownOnOtherLinks} to="/contact">
              contact
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
